'use client';

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setOfflineMode } from '../redux/slices/offline/offlineSlice';

export default function ServiceWorkerRegistration() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Register for service worker messages
    if ('serviceWorker' in navigator) {
      // Listen for messages from service worker
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data && event.data.type === 'OFFLINE_DETECTED') {
          dispatch(setOfflineMode(true));
        }
      });

      // Listen for controlled changes
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        console.log('Service worker controller changed');

        // Clear API cache when controller changes (new service worker takes over)
        if (navigator.serviceWorker.controller) {
          navigator.serviceWorker.controller.postMessage({
            type: 'CLEAR_API_CACHE'
          });
        }
      });

      // Verify service worker and clear API cache on initial load
      setTimeout(() => {
        if (navigator.serviceWorker.controller) {
          console.log('Service worker is active, clearing API cache');
          navigator.serviceWorker.controller.postMessage({
            type: 'CLEAR_API_CACHE'
          });
        } else {
          console.warn('No active service worker found');
        }
      }, 3000); // Wait 3 seconds for service worker to initialize
    }

    // Function to update online status in Redux
    const updateOnlineStatus = () => {
      const isOnline = navigator.onLine;
      if (!isOnline) {
        dispatch(setOfflineMode(true));
      }
    };

    // Add event listeners for online/offline status
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    // Initial check
    updateOnlineStatus();

    // Cleanup event listeners
    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    };
  }, [dispatch]);

  return null;
} 